// The TxnScreenRuntime of an IOFlow flow's input form (nav obj_type "J",
// docs/flow_forms.md). Everything a form needs while it is being filled —
// item_change, lookups, defaults, rights, uploads — is the ordinary platform
// transport (makeDesignerScreenRuntime). What differs is what the form never
// has and what its one button does:
//
//   * no saved records: `list` is empty and `load` / `remove` refuse;
//   * no backing table to prepare (`ensureReady` absent) and no Make changes;
//   * `saveBatch` RUNS THE FLOW (`/livepreview/flow/run`): the server validates
//     the buffer with the engine, builds the flow's variables from the model
//     and starts the flow. Its 422 is the batch save's own envelope, so the
//     screen shows validation errors on the field / row exactly as on Save.

import type { TxnScreenRuntime, BatchSaveResult } from '@twasta/page-runtime/txn/screen'
import type { ListResponse } from '@twasta/page-runtime/txn/contracts'
import { runFlowMenu } from '@/api/flowForms'
import { makeDesignerScreenRuntime } from './designerScreenRuntime'

/** What a successful flow run hands back to the screen's `submit.onDone`. */
export type FlowRunResult = BatchSaveResult & { execution_id: string }

export function makeFlowFormRuntime(project: string, objName: string): TxnScreenRuntime {
  const base = makeDesignerScreenRuntime(project)
  const empty: ListResponse = { ok: true, rows: [], total: 0 }
  return {
    ...base,
    build: undefined,
    ensureReady: undefined,
    list: async () => empty,
    load: async () => {
      throw new Error('A flow input form keeps no saved records.')
    },
    remove: async () => {
      throw new Error('A flow input form keeps no saved records.')
    },
    saveBatch: async (_obj, body): Promise<FlowRunResult> => {
      const res = await runFlowMenu(project, objName, {
        header: body.header,
        details: body.details as Record<string, unknown>,
        ignore_warnings: body.ignore_warnings,
      })
      return {
        ok: true,
        txn_id: res.execution_id,
        execution_id: res.execution_id,
        header: body.header,
        details: {},
      }
    },
  }
}
